import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import Grid from '@mui/material/Grid';

import {Dispatch, Store} from 'spectra-logic-ui';
import {fetchResource} from 'spectra-logic-ui/actions';
import {SlidePanel} from 'spectra-logic-ui/components';

import {Action} from '@/types';
import {IAMUser, IAMGroup} from '@/iam/types';
import IAMGroups from '@/iam/groups';
import IAMUsers from '@/iam/users';
import Actions from '@/iam/users/details/actions';
import IAMUserGroups from '@/iam/users/details/groups';
import UserProperties from '@/iam/users/details/properties';
import GroupProperties from '@/iam/groups/details/properties';
import GroupUsers from '@/iam/groups/details/users';
import GroupPolicies from '@/iam/groups/details/policies';
import AccessKeys from '@/iam/users/details/keys';

type Props = {
  actions: Action[];
  fetchActions?: () => Promise<any>;
}

const Users = ({actions, fetchActions}: Props) => {
  const [selectedUser, setSelectedUser] = useState({} as IAMUser);
  const [selectedGroup, setSelectedGroup] = useState({} as IAMGroup);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const openDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);
  const selectIAMUser = (user: IAMUser) => {
    setSelectedUser(user);
    setSelectedGroup({} as IAMGroup);
  };
  const selectIAMGroup = (group: IAMGroup) => {
    setSelectedUser({} as IAMUser);
    setSelectedGroup(group);
  };

  useEffect(() => {
    if (fetchActions !== undefined) {
      fetchActions();
    }
  }, []);

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <IAMUsers
            selectedUser={selectedUser} selectUser={selectIAMUser} openDrawer={openDrawer} closeDrawer={closeDrawer}
          />
        </Grid>
        <Grid item xs={12}>
          <IAMGroups
            selectedGroup={selectedGroup} selectGroup={selectIAMGroup} openDrawer={openDrawer} closeDrawer={closeDrawer}
          />
        </Grid>
      </Grid>
      <Panel
        selectedUser={selectedUser} selectedGroup={selectedGroup} isDrawerOpen={isDrawerOpen} closeDrawer={closeDrawer}
        actions={actions}
      />
    </>
  );
};

const mapStateToProps = (state: Store) => {
  const actionsResource = state.resources.actions || {};
  return {
    actions: actionsResource.data,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchActions: () => dispatch(fetchResource('actions')),
});

type PanelProps = {
  selectedUser: IAMUser;
  selectedGroup: IAMGroup;
  isDrawerOpen: boolean;
  closeDrawer: (...args: any) => any;
  actions: Action[];
};

const Panel = ({selectedUser, selectedGroup, isDrawerOpen, closeDrawer, actions=[]}: PanelProps) => {
  const title = selectedUser.username ? selectedUser.username : selectedGroup.name;

  let options: string[];
  let tabs: any[];
  if (selectedUser.username) {
    options = ['Properties', 'IAM Groups', 'Access Keys'];
    tabs = [
      <UserProperties key='userProps' user={selectedUser} />,
      <IAMUserGroups key='groups' user={selectedUser} />,
      <AccessKeys key='keys' user={selectedUser} />,
    ];
    if (actions.length > 0) {
      options.push('Actions');
      tabs.push(<Actions key='actions' actions={actions} user={selectedUser} />);
    }
  } else {
    options = ['Properties', 'Users', 'Policies'];
    tabs = [
      <GroupProperties key='groupProps' group={selectedGroup} />,
      <GroupUsers key='users' group={selectedGroup} />,
      <GroupPolicies key='policies' group={selectedGroup} />,
    ];
  }

  return (
    <SlidePanel title={title} options={options} open={isDrawerOpen} onClose={closeDrawer}>
      {tabs}
    </SlidePanel>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);
